import { setCountAction } from "./_common.js";

const main = () => {
    if (document.querySelector('#page-search-school') == null) return;

    document.querySelector('select[name="school_area"]').addEventListener('change', (e) => {
        const urlBase = location.href.replace(/\/\d+$/, '').replace(/\/$/, '');
        location.href = `${urlBase}/${e.currentTarget.value}`;
    });
    setCountAction();
}

export default main
